<template>
  <div class="tabs-list ad-d-flex ad-d-flex-start">
    <div v-for="(tab,key) in tabs"
         @click="changeActiveTab(tab,key)"
         :key="key"
         :style="{width:`${size}px`}"
         class="tabs-list-tab pointer no-select ad-d-flex ad-d-flex-start"
         :class="{'active':tab.value===activeIndex}">
      <template v-if="tab.icon">
        <byted-icon :name="tab.icon" class="ad-m-r-xs"></byted-icon>
      </template>
      <div class="tabName">
        {{tab.text}}
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'tabs-list',
    props: {
      onChangeActiveTab: {
        type: Function,
        default: null
      },
      size: {
        type: [String, Number],
        default: 212,
      },
      tabs: {
        type: [Array, Object],
        default: []
      },
      activeIndex: {
        type: [String, Number],
        default: ''
      },
      type: {
        type: String,
        default: 'campaign'
      }
    },
    methods: {
      changeActiveTab(tab, key){
        this.onChangeActiveTab && this.onChangeActiveTab(tab, key)
      }
    }
  }
</script>
<style lang="scss">
  $normal-color: #333;
  $hover-color: #2F88FF;
  $active-color: #2f88ff;
  $border-radius: 3px;

  .tabs-list {
    height: 40px;
    /*background: #F3F3F4;*/
    background: #dadfe3;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: bold;
    color: #666;
    border-radius: $border-radius $border-radius 0 0;
    &-tab.active + &-tab, &-tab:first-of-type, &-tab.active {
      &::after {
        background: transparent;
      }
    }
    &-tab {
      border-top: 3px solid #dadfe3;
      height: 100%;
      padding: 0 16px;
      position: relative;
      border-radius: $border-radius $border-radius 0 0;
      .tabName{
        position: relative;
        top: 0.5px;
      }
      &::after {
        content: '';
        position: absolute;
        width: 1px;
        left: 0;
        padding: 8px 0;
        background: #CFD2D6;
      }
      $tab-icon-size: 20px;
      .byted-icon {
        width: $tab-icon-size;
        height: $tab-icon-size;
        fill: #666666;
      }
      &:hover {
        border-color: #E8ECEE;
        background:rgba(255,255,255,0.4);
        color: $hover-color;
        .byted-icon {
          fill: $hover-color;
        }
      }
      &.active {
        border-top: 3px solid #2F88FF;
        background: #fff;
        border-radius: $border-radius $border-radius 0 0;
        color: $active-color;
        .byted-icon {
          fill: $active-color;
        }
      }
    }
  }
</style>
